import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Component from '../../components/Component';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Typography } from '@mui/material';
import MissionsNav from './MissionsNav';
import MissionList from './MissionList';
import MissionEditor from './MissionEditor';
import ParticipantsList from './ParticipantsList';
import ParticipantDetail from './ParticipantDetail';

function Missions() {
  return (
    <Component>
      <div
        className="missions-container"
        style={{
          marginLeft: '280px',
          marginTop: '80px',
          padding: '20px',
          width: 'calc(100% - 280px)',
        }}
      >
        <div className="d-flex align-items-center mb-2">
          <IconButton style={{ background: '#FFFFFF' }} component={Link} to="/">
            <ArrowBackIcon />
          </IconButton>
          <div style={{ marginLeft: '12px' }}>
            <h2 style={{ margin: 0 }}>Missions Admin</h2>
            <Typography variant="body2" color="text.secondary">
              Career missions and participant progress. The daily schedule is on{' '}
              <Link to="/admin/daily-missions?from=today">Daily Missions</Link>.
            </Typography>
          </div>
        </div>

        <MissionsNav />

        <Routes>
          <Route index element={<MissionList />} />
          <Route path="new" element={<MissionEditor />} />
          <Route path="participants" element={<ParticipantsList />} />
          <Route path="participants/:subjectType/:subjectId" element={<ParticipantDetail />} />
          <Route path=":id" element={<MissionEditor />} />
          <Route path="configure/*" element={<Navigate to="/admin/missions" replace />} />
        </Routes>
      </div>
    </Component>
  );
}

export default Missions;
